module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAHCAYAAADEUlfTAAAASUlEQVQImXXOsRHCQAADwYOACsHfuIfEldjJknzm55ILpNEohA07zukNhbc1W7O5Yn/grF7duZ7VsQiqjvD5Mzuabwe+uKYH+gH5PIfXld4BbgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/disc.png
// module id = 247
// module chunks = 1